import { api } from './api';

// ── Spec 051 AC-20 + Spec 052 — payment details on the admin order detail (billing svc) ──

export interface AdminPaymentDetail {
  id: string;
  amount: number;
  currency: string;
  paymentMethodUsed: string | null;
  transactionRef: string | null;
  /** @deprecated mirrors gatewayTransactionId for one release (Spec 052 AC-43) */
  paymobTransactionId: string | null;
  provider: string;
  gatewayTransactionId: string | null;
  gatewayReference: string | null;
  feeAmount: number | null;
  /** true when feeAmount is the provider-reported fee; false = schedule estimate */
  feeIsActual: boolean;
  netAmount: number | null;
  /** Spec 053 AC-13 — provider fee excluding VAT; null until the provider reports the actual fee */
  feeNetAmount: number | null;
  /** Spec 053 AC-13 — VAT charged on the provider fee (recoverable input VAT); null until reported */
  feeTaxAmount: number | null;
  /** provider balance transaction the fee split was read from */
  balanceTransactionId: string | null;
  /** amount − fee − already refunded; null unless the payment is SUCCESS */
  maxRefundable: number | null;
  /** #525 — Σ PROCESSED (settled) refunds on this payment; 0 when there are none, never null */
  refundedAmount: number;
  disputeCount: number;
  status: string;
  createdAt: string;
  updatedAt: string;
  /** Spec 067 — who pays the Tabby fee, frozen at capture: GARAGE | GARAGAT; null for non-Tabby payments. */
  feeBearer?: 'GARAGE' | 'GARAGAT' | null;
  /** Spec 067 DD4 — when the order may be paid out to the garage (Tabby holding period); null otherwise. */
  settlementEligibleAt?: string | null;
  /**
   * Spec 068 V10 — how `amount` splits across the supplies (VAT-inclusive): the garage's service,
   * Garagat's pickup & delivery fee and Garagat's service fee. 0.00/null = that slice is absent.
   */
  serviceGross?: number | null;
  deliveryFeeGross?: number | null;
  serviceFeeGross?: number | null;
}

/** A gateway chargeback (Spec 052 AC-42). NOT the order's DISPUTED status. */
export interface AdminPaymentDispute {
  id: string;
  provider: string;
  gatewayDisputeId: string;
  amount: number;
  currency: string;
  reason: string | null;
  status: string;
  evidenceDueBy: string | null;
  openedAt: string;
  closedAt: string | null;
}

export const adminPaymentsApi = {
  getPayment: (paymentId: string, token: string) =>
    api.get<AdminPaymentDetail>(`/api/admin/payments/${paymentId}`, token),
  listDisputes: (paymentId: string, token: string) =>
    api.get<AdminPaymentDispute[]>(`/api/admin/payments/${paymentId}/disputes`, token),
};
